import React, { useRef } from "react";
import PropTypes from "prop-types";

const MultiInput = ({
  placeholder,
  Wrapper,
  wrapperProps,
  values,
  onChange,
  keyName,
  regex,
}) => {
  const multiInputRef = useRef();

  const handleKeypress = (event) => {
    if (event.key === "," || event.key === "Enter") {
      event.preventDefault();
      const newValue = event.target.value;
      if (!regex || new RegExp(regex).test(newValue)) {
        if (!values.includes(newValue) && newValue.trim() !== "") {
          const newValues = [...values, newValue];
          onChange(newValues);
        }
        multiInputRef.current.value = "";
      } else {
      }
    }
  };

  const removeItem = (index) => {
    const newValues = values.filter((value) => value !== values[index]);
    onChange(newValues);
  };

  const generateElements = () => {
    return values.map((value, i) => {
      const props = Wrapper !==React.Fragment? wrapperProps : null;
      if (Wrapper === "a") {
        props.href = value;
      } 
      return (
        <div className="tag" key={`${keyName}-${i}`}>
          <Wrapper {...props}> {value} </Wrapper>{" "}
          <i className="fas fa-times" onClick={() => removeItem(i)}> </i>
        </div>
      );
    });
  };

  return (
    <>
      <div>{generateElements()}</div>
      <input
        type="text"
        placeholder={placeholder}
        onKeyPress={handleKeypress}
        ref={multiInputRef}
      />
    </>
  );
};

MultiInput.defaultProps = {
  Wrapper: React.Fragment,
  wrapperProps: {},
  initialValue: "",
  value: [],
  keyName: "multi-input",
  placeholder: "New",
};

MultiInput.prototypes = {
  value: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  Wrapper: React.Fragment,
  regex: PropTypes.string,
  placeholder: PropTypes.string,
};

export default MultiInput;
